import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { RCCInput, RCCHookToast, RCCButton, RCCGrid, RCCCheckBox } from "react-common-components";
import { useForm } from "react-hook-form";
import {getValidationErrors, standardErrorMessages} from "src/utils/errors";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import LoginScreen from "src/components/LoginScreen";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import { IPageLoginFormSubmit } from "./interface";

const Login: React.FC = () => {
	const [buttonLoading, setButtonLoading] = useState(false);
	const { translate } = useTranslation();
	const history = useHistory();
	const { register, setError, clearErrors, handleSubmit, formState: { errors } } = useForm();
	const { addToast } = RCCHookToast();
	const {signIn} = useAuth();

	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);
	
	const submitForm = async (data: IPageLoginFormSubmit) :Promise<void> => {
		try
		{
			setButtonLoading(true);
			clearErrors();
			const schema = Yup.object().shape({
				email: Yup.string().required(translate("Usuário/E-mail é obrigatório")),
				password: Yup.string().required(translate("Senha é obrigatório"))
			});

			await schema.validate(data, {
				abortEarly: false
			});
		
			await signIn({
				email: data.email,
			    password: data.password,
				executeBeforeTFA: () => setButtonLoading(false),
				remember: data.remember
			});

			if(objQueryParams && objQueryParams.redirect)
				history.push(objQueryParams.redirect);
		}
		catch(err)
		{
			setButtonLoading(false);
			if(getValidationErrors(err, setError))
				return;

			standardErrorMessages(err, translate("Verifique os campos e tente novamente"), addToast);
		}
	};

	return (
		<LoginScreen contentPosition="end">
			<form onSubmit={handleSubmit(submitForm)}>
				<h1>{translate("Acessar Scoreplan")}</h1>
				<RCCInput 
					name="email" 
					type="email"
					label="Email"
					register={register} 
					error={errors.email}
					layout="outlined"
					icon={{
						name: "user",
						color: "var(--purple-lighter)"
					}}
				/>
				<br />
				<RCCInput 
					name="password" 
					label={translate("Senha")}
					type="password" 
					register={register} 
					error={errors.password}
					layout="outlined"
					icon={{
						name: "lock",
						color: "var(--purple-lighter)"
					}}
				/>
				<br />
				<RCCGrid container item alignItems="center" justifyContent="space-between">
					<RCCCheckBox 
						name="remember"
						defaultChecked
						label={translate("Lembrar-me")}
						labelPosition="end"
						register={register}	
						styleInline={{
							label: "color: var(--input-font-color); font-size: 0.9rem;"
						}}
					/>
					<Link to="/forgot">{translate("Esqueci minha senha")}</Link>
				</RCCGrid>
				<RCCButton 
					color="purple" 
					type="submit" 
					loading={buttonLoading}
					loadingText={translate("Carregando")}
					styleInline={`
								padding: 24px;
								width: 100%;
								>span.span-of-component-button{
									font-size: 1rem;
									font-weight: bold;
								}
							`}
				>{translate("Entrar")}</RCCButton>
				<RCCGrid container item justifyContent="center">
					<RCCButton 
						color="transparent"
						icon={{
							name: "microsoft",
							color: "var(--default-color-font)"
						}} 
						onClick={() => history.push("/login/microsoft")}
						styleInline={`
						padding: 12px;
						color: var(--default-color-font);
						border: none;
						margin-top: 1rem;
						>span.span-of-component-button{
							font-size: 1rem;
							font-weight: bold;
						}
					`}
					>{translate("Entrar com a Microsoft")}</RCCButton>
				</RCCGrid>
			</form>
		</LoginScreen>
	);
};

export default Login;
